// Parametry śledzące kampanii (Google Ads, Meta, newslettery…): nie zmieniają treści strony.
// Nie trafiają do canonical ani do klucza reguły SEO, normalizacja adresu (308) nie zmienia ich wartości,
// a linki paginacji ich nie przenoszą. Porównanie po początku nazwy (utm_source, utm_medium…).
const TRACKING_PARAM_PREFIXES = [
    'utm_',
    'gclid',
    'gbraid',
    'wbraid',
    'gad_',
    'dclid',
    'fbclid',
    'msclkid',
    'yclid',
    'ttclid',
    'igshid',
    'srsltid',
    'mc_cid',
    'mc_eid',
    '_ga',
    '_gl',
]

const isTrackingParam = (key) => typeof key === 'string' && TRACKING_PARAM_PREFIXES.some(prefix => key.startsWith(prefix))

// CommonJS — moduł importuje też skrypt porządków reguł SEO (Node)
module.exports = {
    TRACKING_PARAM_PREFIXES,
    isTrackingParam,
}
